import { render, staticRenderFns } from "./AIChat_Comment.vue?vue&type=template&id=1ad276d6&scoped=true"
import script from "./AIChat_Comment.vue?vue&type=script&lang=js"
export * from "./AIChat_Comment.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Comment.vue?vue&type=style&index=0&id=1ad276d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad276d6",
  null
  
)

export default component.exports